import {cartDelivery} from 'modules/cart-delivery'
import {cartPayment} from 'modules/cart-payment'
import {cartOrder} from 'modules/cart-order'
import {AjaxCart} from 'modules/ajax-cart'
import { Cookie } from 'modules/cookie'

class BasketLink {
  constructor() {
      this.init();
  }
  init() {
      console.log('[ BasketLink ] init');
      this.delivClick();
  }
  delivClick() {
    		$("body,html").animate({scrollTop: 0}, 400);
      $.ajax({
        method: "POST",
        url:'/oa/Get_Shipment/',
      }).then((data) => {
        $('.js-tabs__content').html(data.content);
        console.log('[ BasketLink ] Kkkkkk');
          $('.js-tabs__item').removeClass('tabs__item--active tabs__item--postactive').addClass('tabs__item--noactive');
          $('.js-tabs__item[data-type="basket"]').addClass('tabs__item--active tabs__item--postactive');
          $('.js-tabs__item[data-type="shipment"]').addClass('tabs__item--active');
          this.backToBask();
          this.toPay();
          this.changeCity();
          $('.js-form-order__btn').prop('disabled',true);
      });
  }
  toPay() {

    $('.js-form-order__btn').click(function(){
      $("body,html").animate({scrollTop: 0}, 400);
      $.ajax({
        method: "POST",
        url:'/oa/Get_Payment/',
      }).then((data) => {
        $('.js-tabs__content').html(data.content);
        console.log('[ BasketLink ] toPay');
        cartPayment();
        $('input[type="tel"]').mask('9 (999) 999-99-99');
		this.cookie = new Cookie();
        $('.js-tabs__item').removeClass('tabs__item--active tabs__item--postactive').addClass('tabs__item--noactive');
        $('.js-tabs__item[data-type="basket"]').addClass('tabs__item--active tabs__item--postactive');
        $('.js-tabs__item[data-type="shipment"]').addClass('tabs__item--active tabs__item--postactive');
        $('.js-tabs__item[data-type="payment"]').addClass('tabs__item--active');
        $('.js-form-order__delivery-change, .js-tabs__item.tabs__item--postactive[data-type="shipment"]').click(function(){
          this.bask = new BasketLink();
        });
        $('.js-form-order__more').click(function(){
	    $('.js-skriti__block').slideToggle();
	    $(this).toggleClass('m--open');
		    if ($(this).hasClass('m--open')) {
		      $(this).text('Скрыть');
		    } else {
		      $(this).text('И еще '+$('.js-skriti__block').find('.form-order').length+' товар');
		    }
		 })
        $('.js-form-order__backcart').click(function(){
          $.ajax({
            method: "POST",
            url:'/oa/Get_Basket/',
          }).then((data) => {
            $('.js-tabs__content').html(data.content);
            this.aji = new AjaxCart;
            cartOrder();
            $('.js-tabs__item').removeClass('tabs__item--active tabs__item--postactive').addClass('tabs__item--noactive');
            $('.js-tabs__item[data-type="basket"]').addClass('tabs__item--active');
          });
        })
      });
    })
  }
  backToBask() {
    console.log('[ BasketLink ] Ssss');
    $('.js-form-order__backcart, .js-tabs__item.tabs__item--postactive[data-type="basket"]').click(function(){
      $("body,html").animate({scrollTop: 0}, 400);
      $.ajax({
        method: "POST",
        url:'/oa/Get_Basket/',
      }).then((data) => {
        $('.js-tabs__content').html(data.content);
        this.aji = new AjaxCart;
        cartOrder();
        $('.js-tabs__item').removeClass('tabs__item--active tabs__item--postactive').addClass('tabs__item--noactive');
        $('.js-tabs__item[data-type="basket"]').addClass('tabs__item--active');
      });
    })
  }
  changeCity() {
  	$('.js-form-order__more').click(function(){
    $('.js-skriti__block').slideToggle();
    $(this).toggleClass('m--open');
	    if ($(this).hasClass('m--open')) {
	      $(this).text('Скрыть');
	    } else {
	      $(this).text('И еще '+$('.js-skriti__block').find('.form-order').length+' товар');
	    }
	  })
    $('.js-shipment__types').addClass('m--loader');
    $('.js-shipment__types').html('');
    var inf = {
      city_id : $('.js-selectcity__select').data('city_id'),
    }
    $.ajax({
      method: "POST",
      url:'/oa/Select_City/',
      data: inf,
      dataType:'json'
    }).then((data) => {
      $('.js-shipment__types').html(data.content);
      $('.js-shipment__types').removeClass('m--loader');
      cartDelivery();
      if ((data.mark != "cdek_pickup" && data.mark != "") || data.pvz != null) {
        $('.js-form-order__btn').prop('disabled',false);
        $('.js-form-order__info-pvz').addClass('m--hidden');
      } else {
        $('.js-form-order__btn').prop('disabled',true);
        $('.js-form-order__info-pvz').removeClass('m--hidden');
        $('.delivery-cost').html(data.shipment_sum +' <span class="rubles">₽</span>');
        $('.total__price').html(data.total_sum +' <span class="rubles">₽</span>')
      }
    })
    $('.js-selectcity__select').click(function(){
        $('.js-shipcity__result').css('display','block');
      })
      $('.js-selectcity__select').on('focus',function(){
        $('.js-efects-click').addClass('active');
      })
      $('.js-selectcity__select').on('keyup',function(){
        if ($(this).val().length > 1) {
          $.ajax({
            method: "POST",
            url: "/cities/",
            data: { term: $(this).val()}
          }).then((data) => {
            $('.js-shipcity__result').html('');
            for (var i = 0; i < 50 && i<data.length; i++) {
              $('.js-shipcity__result').append('<div data-city_id="'+data[i].value+'" class="js-city-item selectmark__term--item">'+data[i].label+'</span></div>');
            }
            $('.js-shipcity__result').css('display','block');
            $('.js-shipcity__result .js-city-item').on('click',function(){
              $('.js-selectcity__select').val($(this).text());
              $('.js-shipment__types').addClass('m--loader');
              $('.js-shipment__types').html('');
              var inf = {
                city_id : $(this).data('city_id'),
              }
              $('.js-shipcity__result').css('opacity','0');
              $.ajax({
                method: "POST",
                url:'/oa/Select_City/',
                data: inf,
                dataType:'json'
              }).then((data) => {
                $('.js-shipcity__result').css('display','none');
                $('.js-shipcity__result').css('opacity','1');
                $('.js-shipment__types').html(data.content);
                $('.js-shipment__types').removeClass('m--loader');
                cartDelivery();
                if ((data.mark != "cdek_pickup" && data.mark != "") || data.pvz != null) {
                  $('.js-form-order__btn').prop('disabled',false);
                } else {
                  $('.js-form-order__btn').prop('disabled',true);
                }
              })
            })
          })
        }
      })
      $('.js-selectcity__select').on('click',function(){
        if ($(this).val().length > 1) {
          $.ajax({
            method: "POST",
            url: "/cities/",
            data: { term: $(this).val()}
          }).then((data) => {
            $('.js-shipcity__result').html('');
            for (var i = 0; i < 50 && i<data.length; i++) {
              $('.js-shipcity__result').append('<div data-city_id="'+data[i].value+'" class="js-city-item selectmark__term--item">'+data[i].label+'</span></div>');
            }
            $('.js-shipcity__result').css('display','block');
            $('.js-shipcity__result .js-city-item').on('click',function(){
              $('.js-selectcity__select').val($(this).text());
              $('.js-shipment__types').addClass('m--loader');
              $('.js-shipment__types').html('');
              var inf = {
                city_id : $(this).data('city_id'),
              }
              $('.js-shipcity__result').css('opacity','0');
              $.ajax({
                method: "POST",
                url:'/oa/Select_City/',
                data: inf,
                dataType:'json'
              }).then((data) => {
                $('.js-shipcity__result').css('display','none');
                $('.js-shipcity__result').css('opacity','1');
                $('.js-shipment__types').html(data.content);
                $('.js-shipment__types').removeClass('m--loader');
                cartDelivery();
                if ((data.mark != "cdek_pickup" && data.mark != "") || data.pvz != null) {
                  $('.js-form-order__btn').prop('disabled',false);
                } else {
                  $('.js-form-order__btn').prop('disabled',true);
                }
              })
            })
          })
        }
      })
      $(document).mouseup(function (e){
          var div = $(".js-shipcity__result");
          if ((!div.is(e.target) && $('.js-city__input').val() == '')) {
            $('.js-efects-click').removeClass('active');
          }
          if (!div.is(e.target)) {
            $('.js-shipcity__result').css('display','none');
          }
      })
  }
}

export {
  BasketLink
}
